import { FC } from 'react'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { useRankingIsEnabled } from '../../../graphql/talents-season/useRankingIsEnabled'
import { Country } from '../../../types'
import { CultivatingTalentsWithRankingAndTagAssignment } from './CultivatingTalentsWithRankingAndTagAssignment'
import { CultivatingTalentsWithTagAssignment } from './CultivatingTalentsWithTagAssignment'

interface CultivatingTalentsViewProps {
  companyId: string
  country: Country
  isHRSettings: boolean
  isAllCompaniesSettings: boolean
  isYourCompanyView: boolean
}

export const CultivatingTalentsView: FC<CultivatingTalentsViewProps> = ({
  companyId,
  country,
  isHRSettings,
  isAllCompaniesSettings,
  isYourCompanyView,
}) => {
  const { data, error, loading } = useRankingIsEnabled(companyId, country)

  if (loading || error || !data) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} showSpinner />
  }

  return (
    <>
      {data.isRankingEnabledForCompanyAndCountry ? (
        <CultivatingTalentsWithRankingAndTagAssignment
          country={country}
          companyId={companyId}
          isHRSettings={isHRSettings}
          isAllCompaniesSettings={isAllCompaniesSettings}
          isYourCompanyView={isYourCompanyView}
        />
      ) : (
        <CultivatingTalentsWithTagAssignment
          country={country}
          companyId={companyId}
          isHRSettings={isHRSettings}
          isAllCompaniesSettings={isAllCompaniesSettings}
          isYourCompanyView={isYourCompanyView}
        />
      )}
    </>
  )
}
